import type { CustomerScreenKey } from '@/nav/keys';

/** URL segment under / for each customer screen. */
export const CUSTOMER_PATH_BY_SCREEN: Record<
  Exclude<CustomerScreenKey, 'login' | 'register'>,
  string
> = {
  home: 'home',
  bills: 'bills',
  products: 'products',
  wallet: 'wallet',
  orders: 'orders',
  more: 'more',
  support: 'support',
  kyc: 'kyc',
  notifications: 'notifications',
  partnerApi: 'partner-api',
  sessions: 'sessions',
  account: 'account',
  quickpay: 'quickpay',
  customers: 'customers',
  distributor: 'distributor',
  debts: 'debts',
  reports: 'reports',
};

const SCREEN_BY_PATH = new Map<string, CustomerScreenKey>([
  ...Object.entries(CUSTOMER_PATH_BY_SCREEN).map(([screen, path]) => [
    path,
    screen as CustomerScreenKey,
  ] as const),
  ['login', 'login'],
  ['register', 'register'],
]);

export const CUSTOMER_LOGIN_PATH = 'login';
export const CUSTOMER_REGISTER_PATH = 'register';
export const CUSTOMER_DEFAULT_PATH = CUSTOMER_PATH_BY_SCREEN.home;

export function customerPathForScreen(screen: CustomerScreenKey): string {
  if (screen === 'login') return `/${CUSTOMER_LOGIN_PATH}`;
  if (screen === 'register') return `/${CUSTOMER_REGISTER_PATH}`;
  return `/${CUSTOMER_PATH_BY_SCREEN[screen]}`;
}

export function customerScreenFromPath(pathname: string): CustomerScreenKey | null {
  const segment = pathname.replace(/^\/+|\/+$/g, '').split('/')[0] ?? '';
  if (!segment) return null;
  return SCREEN_BY_PATH.get(segment) ?? null;
}

export function isCustomerAuthScreen(screen: CustomerScreenKey | null): boolean {
  return screen === 'login' || screen === 'register';
}
